import { api } from "@/redux/api";

import { ProfilesRequestPaginationParams, RequestPaginationParams } from "@/types/request-params";

import { GetAllUsersResponse } from "@/types/admin";

import {
	CreateLiProfileVisits,
	LiProfileVisits,
	LiProfileVisitsResponse,
	LiProfileVisitsResponseSchema,
	LiProfileVisitsSchema,
	UpdateLiProfileVisits,
} from "../../pages/LiProfileVisits/schema/liProfileVisits";
import { GetAllUsersResponseSchema } from "../../pages/Users/schema/get-users";

export const liProfileVisitsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getLiProfileVisits: builder.query<LiProfileVisitsResponse, RequestPaginationParams>({
			query: (params) => ({
				url: "liProfileVisits",
				params: {
					...(params && { ...params }),
				},
				responseSchema: LiProfileVisitsResponseSchema,
			}),
			providesTags: ["LiProfileVisits"],
		}),
		getLiProfileVisit: builder.query<LiProfileVisits, number>({
			query: (id: number) => ({
				url: `liProfileVisits/${id}`,
				params: {
					id,
				},
				responseSchema: LiProfileVisitsSchema,
			}),
			providesTags: ["LiProfileVisits"],
		}),
		getProfiles: builder.query<GetAllUsersResponse, RequestPaginationParams>({
			query: (params) => ({
				url: `users/profiles`,
				params: {
					...(params && { ...params }),
				},
				responseSchema: GetAllUsersResponseSchema,
			}),
			providesTags: ["Profiles"],
		}),
		getProfilesWithLiSn: builder.query<GetAllUsersResponse, ProfilesRequestPaginationParams>({
			query: (params) => ({
				url: `users/profiles`,
				params: {
					...(params && { ...params }),
				},
				responseSchema: GetAllUsersResponseSchema,
			}),
			providesTags: ["ProfilesWithLiSn"],
		}),
		getProfilesWithAdminPermissions: builder.query<
			GetAllUsersResponse,
			ProfilesRequestPaginationParams
		>({
			query: (params) => ({
				url: `users/admin-profiles`,
				params: {
					...(params && { ...params }),
				},
				responseSchema: GetAllUsersResponseSchema,
			}),
			providesTags: ["ProfilesWithAdminPermissions"],
		}),
		createLiProfileVisits: builder.mutation<Partial<LiProfileVisits>, CreateLiProfileVisits>({
			query: (body) => ({
				url: `liProfileVisits`,
				method: "POST",
				body,
				responseSchema: LiProfileVisitsSchema,
			}),
			invalidatesTags: (result, error, arg) => {
				if (arg.listId) {
					return [{ type: "List", id: arg.listId }, "LiProfileVisits"];
				}

				return ["LiProfileVisits"];
			},
		}),
		updateLiProfileVisits: builder.mutation<Partial<LiProfileVisits>, UpdateLiProfileVisits>({
			query: ({ id, ...body }) => ({
				url: `liProfileVisits/${id}`,
				method: "PATCH",
				body,
				responseSchema: LiProfileVisitsSchema,
			}),
			invalidatesTags: ["LiProfileVisits"],
		}),
		deleteLiProfileVisits: builder.mutation<Partial<LiProfileVisits>, { id: number }>({
			query: ({ id }) => ({
				url: `liProfileVisits/${id}`,
				method: "DELETE",
				responseSchema: LiProfileVisitsSchema,
			}),
			invalidatesTags: ["LiProfileVisits"],
		}),
	}),
});

export const {
	useGetLiProfileVisitsQuery,
	useLazyGetLiProfileVisitsQuery,
	useGetLiProfileVisitQuery,
	useUpdateLiProfileVisitsMutation,
	useDeleteLiProfileVisitsMutation,
	useCreateLiProfileVisitsMutation,
	useGetProfilesQuery,
	useGetProfilesWithLiSnQuery,
	useGetProfilesWithAdminPermissionsQuery,
} = liProfileVisitsApi;
export const accountApiReducer = liProfileVisitsApi.reducer;
export const accountApiMiddleware = liProfileVisitsApi.middleware;
